var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-container"},[_c('i',{staticClass:"full-screen-button fas fa-expand",on:{"click":function($event){return _vm.toggleFullScreenMode($event)}}}),_c('viewer',{attrs:{"test":true,"images":[_vm.imageUrl],"options":_vm.viewerOptions}},[_c('img',{key:_vm.imageUrl,staticClass:"preview-image",attrs:{"src":_vm.imageUrl}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }